// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2Tr10","alertIcon":"ConfirmModal_alertIcon__BMu81"};